export default "<app-login [isDialog]=\"true\" (closeComponent)=\"onNoClick()\"></app-login>"